// Languages the admin edits for the app's Contact / About / FAQ content
// (App Config page). Must match the app's shipped languages
// (fincurry_app/lib/l10n/app_*.arb). Add a code here when the app gains
// a language — the page shows a tab for it and the public
// /api/app-config falls back to English until it is filled in.
export const CONFIG_LOCALES = ["en", "hi"] as const;

export type ConfigLocale = (typeof CONFIG_LOCALES)[number];

/**
 * A saved per-language map with an empty block for every listed language
 * it lacks — so a newly added language opens as a blank tab instead of
 * crashing the editor. Unknown keys already saved are kept, not dropped.
 */
export function fillLocales<T>(
  saved: Partial<Record<string, T>> | null | undefined,
  empty: () => T,
): Record<ConfigLocale, T> {
  const out: Record<string, T> = { ...(saved ?? {}) } as Record<string, T>;
  for (const l of CONFIG_LOCALES) {
    if (out[l] == null) out[l] = empty();
  }
  return out as Record<ConfigLocale, T>;
}
